import { boolean, object } from "superstruct";

export const GrowaveStorefrontValuesCheckoutUISchema = object({
    canUseCheckoutUI: boolean(),
});
